import { render } from "./technicianDetail.vue?vue&type=template&id=15be4975&scoped=true&ts=true"
import script from "./technicianDetail.vue?vue&type=script&lang=ts"
export * from "./technicianDetail.vue?vue&type=script&lang=ts"

import "./technicianDetail.vue?vue&type=style&index=0&id=15be4975&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15be4975"]])

export default __exports__